import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import ModuleVersionStateBadge from "components/ModuleVersionStateBadge";

import { SharedModuleData } from "../../../gql";

const SharedModulesTableVersionCell = ({
  item: sharedModule,
  ...cellProps
}: TableSimpleCellProps<SharedModuleData>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <ModuleVersionStateBadge
        state={sharedModule.current?.state}
        number={sharedModule.current?.number}
        yanked={sharedModule.current?.yanked}
      />
    </TableSimpleCell>
  );
};

export default SharedModulesTableVersionCell;
